import { render, staticRenderFns } from "./SentimentCheck.vue?vue&type=template&id=64aee1da&scoped=true"
import script from "./SentimentCheck.vue?vue&type=script&lang=ts"
export * from "./SentimentCheck.vue?vue&type=script&lang=ts"
import style0 from "./SentimentCheck.vue?vue&type=style&index=0&id=64aee1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aee1da",
  null
  
)

export default component.exports